/** 地形共用常數 */

/** 高度圖解析度 */
export const HEIGHTMAP_SIZE = 512

/** 世界 XZ 尺寸（可編輯區域） */
export const TERRAIN_WORLD_SIZE = 600

/** 高度縮放 */
export const TERRAIN_HEIGHT_SCALE = 300

/** 預設地面高度比（水面以下），對應 shader 的 DEFAULT_HEIGHT */
export const DEFAULT_HEIGHT_RATIO = 0.45

/** 水面高度比 (0-1)，對應 shader 的 WATER_HEIGHT */
export const WATER_HEIGHT_RATIO = 0.46

/** 水面世界 Y 座標 */
export const WATER_LEVEL = WATER_HEIGHT_RATIO * TERRAIN_HEIGHT_SCALE

/** 玩家身高 */
export const PLAYER_HEIGHT = 1.7

/** 筆刷半徑（世界單位） */
export const BRUSH_RADIUS = 8

/** 筆刷強度（每秒最大高度變化） */
export const BRUSH_STRENGTH = 0.15

/** 初始化高度圖為純水面以下（避免 z-fighting） */
export function createFlatHeightmap(size: number): Float32Array {
  const data = new Float32Array(size * size * 4)
  for (let i = 0; i < size * size; i++) {
    data[i * 4] = DEFAULT_HEIGHT_RATIO // R = 高度（略低於水面）
    data[i * 4 + 1] = 0
    data[i * 4 + 2] = 0
    data[i * 4 + 3] = 0
  }
  return data
}

/** 世界座標 → 高度圖 UV (0-1) */
export function worldToUV(worldX: number, worldZ: number): [number, number] {
  const u = worldX / TERRAIN_WORLD_SIZE + 0.5
  const v = worldZ / TERRAIN_WORLD_SIZE + 0.5
  return [u, v]
}

/** 世界座標 → 高度圖像素座標 */
export function worldToPixel(worldX: number, worldZ: number, size: number): [number, number] {
  const [u, v] = worldToUV(worldX, worldZ)
  const px = Math.max(0, Math.min(size - 1, Math.floor(u * size)))
  const py = Math.max(0, Math.min(size - 1, Math.floor((1 - v) * size)))
  return [px, py]
}

/** 從高度圖採樣世界高度 */
export function sampleHeight(
  worldX: number,
  worldZ: number,
  heightmapData: Float32Array,
  heightmapSize: number,
): number {
  const [px, py] = worldToPixel(worldX, worldZ, heightmapSize)
  const idx = (py * heightmapSize + px) * 4
  const rawHeight = heightmapData[idx] || 0
  return rawHeight * TERRAIN_HEIGHT_SCALE
}
